import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { fontSize } from '@/components/signup/utils/font-size';
import { wacToken } from '@/libraries/design/foundations';

export const InputIcon = ({ valid }: { valid: boolean | undefined }) => {
	const { formatMessage } = useIntl();

	const validMessage = formatMessage({
		id: 'signupForm.accountCreation.validEmailIcon',
		defaultMessage: 'Success',
	});

	const invalidMessage = formatMessage({
		id: 'signupForm.accountCreation.invalidEmailIconError',
		defaultMessage: 'Error',
	});

	if (valid === undefined) {
		return null;
	}

	return valid ? (
		<div css={[iconWrapperCss, iconValidCss]}>
			<CheckCircleIcon label={validMessage} />
		</div>
	) : (
		<div css={[iconWrapperCss, iconInvalidCss]}>
			<ErrorIcon label={invalidMessage} />
		</div>
	);
};

const iconWrapperCss = css({
	alignItems: 'center',
	display: 'flex',
	fill: wacToken('color.neutral.light0'),
	fontSize: fontSize.md,
	paddingInlineEnd: 10,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	svg: {
		width: 20,
		height: 20,
	},
});

const iconValidCss = css({
	color: wacToken('color.extended.lime600'),
});

const iconInvalidCss = css({
	color: token('color.border.danger'),
});
